/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { getAllBlogs } from "../../../lib/Services_with_Query";
import Loader from "../../../Component/Loader/Loader";

const chunkData = (data, size) => {
  const chunks = [];
  for (let i = 0; i < data?.length; i += size) {
    chunks.push(data.slice(i, i + size));
  }
  return chunks;
};

const Blog = ({ agent_id, website_id }) => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();

  const handlePaginationClick = (pageIndex, e) => {
    e?.preventDefault();
    if (swiperInstance) {
      swiperInstance.slideTo(pageIndex);
      setCurrentPage(pageIndex);
    }
  };
  const HandleDetail = (e, post) => {
    e?.preventDefault();
    navigate(`/blog-detail/${post?.id}`, { state: post });
  };
  const shouldFetch = website_id && agent_id ? true : false;
  const { data, isLoading, error } = useQuery({
    queryFn: () => getAllBlogs(website_id, agent_id),
    enabled: shouldFetch,
  });

  if (isLoading) return <Loader />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <>
      <div className="blog-area blog-grid fix area-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="section-headline text-center">
                <div className="section-center-head">
                  <p className="top-head" style={{ fontSize: "50px" }}>
                    Blogs {data?.length === 0 && "Not Found"}
                  </p>
                </div>
                {/* <h2>Latest Blog</h2> */}
              </div>
            </div>
          </div>
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            speed={600}
            navigation
            parallax
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            onSwiper={(swiper) => setSwiperInstance(swiper)}
            onSlideChange={(swiper) => setCurrentPage(swiper.activeIndex)}
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
          >
            {chunkData(data, 3).map((chunk, index) => (
              <SwiperSlide key={index}>
                <div className="row">
                  {chunk.map((post) => (
                    <div key={post.id} className="col-xl-4 col-lg-4 col-md-6">
                      <div className="single-blog">
                        <div className="blog-image">
                          <p
                            className="image-scale"
                            onClick={(e) => HandleDetail(e, post)}
                          >
                            <img
                              style={{ width: "356px", height: "202px" }}
                              src={post?.image}
                              alt=""
                            />
                            <div className="blog-item-date">
                              <span className="date-type">
                                {post?.created_at?.slice(0, 10)}
                              </span>
                              <span className="years-type">
                                {/* {post.date.split(" ")[1]} */}
                              </span>
                            </div>
                          </p>
                          <div className="blog-content">
                            <div className="blog-meta">
                              <span className="admin-type">
                                <i className="fa fa-user" />
                                {post?.subadmin?.fname +
                                  " " +
                                  post?.subadmin?.lname}
                              </span>
                              <span className="comments-type">
                                <i className="fa fa-comment-o" />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: post?.description?.slice(0, 50),
                                  }}
                                />
                                {/* {post.description} */}
                              </span>
                            </div>

                            <h4>{post?.title}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {data?.length !== 0 && (
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="blog-pagination">
                <ul className="pagination">
                  <li>
                    <p
                      onClick={(e) =>
                        handlePaginationClick(Math.max(currentPage - 1, 0), e)
                      }
                    >
                      Prev
                    </p>
                  </li>
                  {Array.from({ length: chunkData(data, 3).length }).map(
                    (_, index) => (
                      <li
                        key={index}
                        className={index === currentPage ? "active" : ""}
                      >
                        <p  onClick={(e) => handlePaginationClick(index, e)}>
                          {index + 1}
                        </p>
                      </li>
                    )
                  )}
                  <li>
                    <p
                      onClick={(e) =>
                        handlePaginationClick(
                          Math.min(
                            currentPage + 1,
                            chunkData(data, 3).length - 1
                          ),
                          e
                        )
                      }
                    >
                      Next
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Blog;
